<template>
  <div class="flex-center">
    <v-btn color="admin" dark outlined @click="onExport">
      <v-icon left>mdi-file-excel-outline</v-icon>Xuất Excel
    </v-btn>
  </div>
</template>
<script>
import {mapActions, mapGetters} from 'vuex'
import * as XLSX from 'xlsx'
import {saveAs} from 'file-saver'
import {get} from 'lodash'
export default {
  computed: {
    ...mapGetters('auth', ['user']),
    ...mapGetters({filterParams: 'cv/filterParams'}),
  },
  methods: {
    ...mapActions({fetchCVsIndependent: 'cv/fetchCVsIndependent'}),
    async onExport() {
      this.$loading.active = true
      const cvs = await this.fetchCVsIndependent({
        ...this.filterParams,
        fromAdmin: true,
        _start: 0,
        _limit: -1,
      })
      const worksheet = XLSX.utils.json_to_sheet(
        cvs.map(cv => {
          const res = {
            'Mã hồ sơ': cv.code,
            'Khối': cv.type,
            'Cơ sở': cv.department,
            'Tên thí sinh': get(cv, 'name'),
            'Số điện thoại đăng ký': cv.parentUsername,
            'Trạng thái': cv.enrollmentFlag === 'enroll' ? 'Nhập học' : cv.enrollmentFlag === 'reserve' ? 'Dự khuyết' : 'Đóng',
            'Trạng thái ĐK nhập học': cv.enrollRegisterState === 'success' ? 'Đã đăng ký nhập học' : '',
            'Trạng thái ĐK DS chờ': cv.reserveRegisterState === 'success' ? 'Đã đăng ký DS chờ' : '',
          }
          return res
        }),
      )
      const workbook = {Sheets: {data: worksheet}, SheetNames: ['data']}
      const excelBuffer = XLSX.write(workbook, {bookType: 'xlsx', type: 'array'})
      const data = new Blob([excelBuffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
      })
      saveAs(data, 'kh-nhap-hoc.xlsx')
      this.$loading.active = false
    },
  },
}
</script>
